const isBrowser = typeof window !== 'undefined';
const log4javascript = isBrowser ? require('log4javascript') : undefined;

import { API_URL, api } from './apiCaller';

const logger = {
  setup() {
    if (!log4javascript) {
      console.log('log4javascript not defined');
      return;
    }

    window.myLogger = log4javascript.getLogger('Nave-FE');

    var errorAjaxAppender = new log4javascript.AjaxAppender(`${API_URL}/log/error`);
    errorAjaxAppender.setThreshold(log4javascript.Level.ERROR);
    errorAjaxAppender.setTimed(true);
    errorAjaxAppender.setTimerInterval(1000);
    errorAjaxAppender.setSendAllOnUnload();

    window.myLogger.addAppender(errorAjaxAppender);
  },

  error(error, details) {
    if (window.myLogger) {
      console.error('ERROR', error, details);
      window.myLogger.error(
        JSON.stringify({
          url: window.location.href,
          message: error,
          stack: details,
          context: navigator.userAgent,
        })
      );
    }
  },

  report(params) {
    console.error('ERROR', params);
    if (window.myLogger) {
      window.myLogger.error(
        JSON.stringify({
          url: window.location.href,
          message: params.error.message,
          stack: params.stackframes,
          info: params.info,
          ua: navigator.userAgent,
        })
      );
    } else {
      api('log/error', 'post', {
        url: window.location.href,
        message: params.error.message,
        stack: params.stackframes,
        info: params.info,
        ua: navigator.userAgent,
      });
    }
  },
};

export default logger;
